module.exports = __webpack_public_path__ + "media/images/reportimages/thought_bubble-69ddb042dbc7b77d61a98043245a6020.png";